import React, { Dispatch, SetStateAction } from 'react';
import { useTypedTranslation } from '@app/hooks';
import { launchYubikeyApp } from '@app/helpers';
import { SetUpDeviceManualToken, Verify } from './';
import { ActiveMethodManageMfa } from '@app/models';
import { Link } from '@material-ui/core';

interface IProps {
    tokenSecret: string;
    encodedKey: string;
    onClickTrouble: () => void;
    setIsDisableButtonNext: Dispatch<boolean>;
    setIsNeedExpandToken: Dispatch<SetStateAction<boolean>>;
    isNeedExpandTokenBlock: boolean;
    isNeedExpandToken: boolean;
    activeMethod: ActiveMethodManageMfa;
    setPassCode: Dispatch<string>;
    passCode: string;
    errorMessage: string;
    setErrorMessage: Dispatch<string>;
}

export const SetUpDeviceYubikeyToken: React.SFC<IProps> = ({
    encodedKey,
    tokenSecret,
    onClickTrouble,
    setIsNeedExpandToken,
    setIsDisableButtonNext,
    isNeedExpandTokenBlock,
    isNeedExpandToken,
    activeMethod,
    setPassCode,
    passCode,
    errorMessage,
    setErrorMessage
}) => {
    const { translation } = useTypedTranslation();
    const launchYubikeyApplication = () => {
        setIsDisableButtonNext(false);
        launchYubikeyApp(tokenSecret);
    };
    return (
        <>
            <div className='manage-mfa-token__part manage-mfa-token__part-2'>
                <span>2. </span>
                <span>
                    {translation('CONFIGURE_AUTHENTICATOR_HEADER')}{' '}
                    <Link className='manage-mfa-token__link' onClick={onClickTrouble} underline='none'>
                        {isNeedExpandTokenBlock ? translation('TROUBLE_LAUNCHING_APP') : translation('RETURN_TO_LAUNCHING_APP')}
                    </Link>
                </span>
            </div>
            {isNeedExpandTokenBlock && (
              <button type='button' id='launch-desktop-app' className='manage-mfa-token__paper--button' onClick={launchYubikeyApplication}>
                  <span className='manage-mfa-token__paper--text'>{translation('LAUNCH_DESKTOP_APP')}</span>
              </button>
            )}
            {!isNeedExpandTokenBlock && <SetUpDeviceManualToken isNeedExpandToken={isNeedExpandToken} encodedKey={encodedKey} />}
            <Verify
              activeMethod={activeMethod}
              setPassCode={setPassCode}
              passCode={passCode}
              errorMessage={errorMessage}
              setErrorMessage={setErrorMessage}
            />
        </>
    );
};
